const reducer = (state = false, action) => {
  switch (action.type) {
    case "REDIRECT":
      return { redirectTo: action.payload };
    default:
      return state;
  }
};

export default reducer;
